var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42857143,0 C0.639514286,0 0,0.639514286 0,1.42857143 C0,2.21762857 0.639514286,2.85714286 1.42857143,2.85714286 L22.5714286,2.85714286 C23.3604857,2.85714286 24,2.21762857 24,1.42857143 C24,0.639514286 23.3604857,0 22.5714286,0 L1.42857143,0 Z M1.42857143,7.71428571 C0.639514286,7.71428571 0,8.3538 0,9.14285714 C0,9.93191429 0.639514286,10.5714286 1.42857143,10.5714286 L22.5714286,10.5714286 C23.3604857,10.5714286 24,9.93191429 24,9.14285714 C24,8.3538 23.3604857,7.71428571 22.5714286,7.71428571 L1.42857143,7.71428571 Z M1.42857143,15.4285714 C0.639514286,15.4285714 0,16.0680857 0,16.8571429 C0,17.6462 0.639514286,18.2857143 1.42857143,18.2857143 L22.5714286,18.2857143 C23.3604857,18.2857143 24,17.6462 24,16.8571429 C24,16.0680857 23.3604857,15.4285714 22.5714286,15.4285714 L1.42857143,15.4285714 Z",
    id: "menu",
    fill: "#BDD23F",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.264ad3321d61e6ff7c7652e459c8c60d.svg";
export { ForwardRef as ReactComponent };